/* oxlint-disable @typescript-eslint/no-unsafe-member-access */
import { Spinner } from '@latitude/spinner';
import { useActionListContext } from 'ActionListContext';
import type { CommandGroupContentProps } from 'types';

import { isValueSelected } from '../utils';
import { CommandEmpty } from './CommandEmpty';
import { CommandGroup } from './CommandGroup';
import { CommandGroupHeaderItem } from './CommandGroupHeaderItem';
import { CommandGroupItem } from './CommandGroupItem';

export const CommandGroupContent = ({
  showSelectionElement,
  itemSize,
  noResultsText = 'No results found.',
  truncateOptions = false,
}: CommandGroupContentProps) => {
  const { filteredOptions, selectedValues, inlineLoading } =
    useActionListContext();

  if (!filteredOptions.length && !inlineLoading) {
    if (!noResultsText) {
      return null;
    }
    return <CommandEmpty>{noResultsText}</CommandEmpty>;
  }

  return (
    <CommandGroup>
      {filteredOptions.map((option, index) => {
        const isLastItem = index === filteredOptions.length - 1;
        if ('items' in option) {
          const hasSeparator =
            option.hasSeparator === undefined ? true : option.hasSeparator;
          return (
            <CommandGroupHeaderItem
              headerItem={option}
              showSelectionElement={showSelectionElement}
              showSeparator={!isLastItem && hasSeparator}
              itemSize={itemSize}
              key={`${index}-${option.items.length}`}
              isTruncated={truncateOptions}
            />
          );
        }

        const isSelected = isValueSelected(selectedValues, option.value);

        return (
          <CommandGroupItem
            key={`${option.value}-${index}`}
            isSelected={isSelected}
            item={option}
            showSelectionElement={showSelectionElement}
            showSeparator={Boolean(option.hasSeparator && !isLastItem)}
            itemSize={itemSize}
            isTruncated={truncateOptions}
          />
        );
      })}
      {inlineLoading ? (
        <CommandGroupItem
          key="inline-loading"
          item={{
            value: 'inlineLoader',
            label: 'Loading',
            leadingIcon: <Spinner />,
            disabled: true,
          }}
          isSelected={false}
          showSelectionElement={false}
          showSeparator={false}
          itemSize={itemSize}
          isTruncated={truncateOptions}
        />
      ) : null}
    </CommandGroup>
  );
};
